import {
  FiArrowLeft,
  FiArrowRight,
  FiCheck,
  FiDownload,
  FiEdit2,
  FiEye,
  FiPaperclip,
  FiPlus,
  FiRotateCcw,
  FiSave,
  FiSearch,
  FiSend,
  FiSlash,
  FiTrash2,
  FiUpload,
  FiUserCheck,
  FiUserX,
  FiUsers,
  FiX,
  FiXCircle
} from 'react-icons/fi';

const LABEL_PREFIX = 'com.tempedge.msg.label.';

const BUTTON_ICONS = {
  cancel: { Icon: FiX },
  save: { Icon: FiSave },
  next: { Icon: FiArrowRight, after: true },
  back: { Icon: FiArrowLeft },
  previous: { Icon: FiArrowLeft },
  edit: { Icon: FiEdit2 },
  add: { Icon: FiPlus },
  find: { Icon: FiSearch },
  search: { Icon: FiSearch },
  advancedsearch: { Icon: FiSearch },
  clean: { Icon: FiRotateCcw },
  selectemployees: { Icon: FiUsers },
  upload: { Icon: FiUpload },
  changefile: { Icon: FiPaperclip },
  choosefile: { Icon: FiPaperclip },
  accept: { Icon: FiCheck },
  confirm: { Icon: FiCheck },
  submit: { Icon: FiSend },
  update: { Icon: FiSave },
  view: { Icon: FiEye },
  delete: { Icon: FiTrash2 },
  download: { Icon: FiDownload },
  approve: { Icon: FiCheck },
  approveselected: { Icon: FiCheck },
  denied: { Icon: FiSlash },
  rejectselected: { Icon: FiSlash },
  activate: { Icon: FiUserCheck },
  terminate: { Icon: FiUserX },
  deleteday: { Icon: FiTrash2 },
  canceltypeoff: { Icon: FiXCircle },
  updatenexus: { Icon: FiSave },
  addPos: { Icon: FiPlus }
};

const ICON_LABEL_KEYS = Object.keys(BUTTON_ICONS).map((name) => `${LABEL_PREFIX}${name}`);

const normalize = (text) => String(text).trim().toLowerCase();

export const findButtonLabelKey = (children, translate) => {
  if (children?.props?.id) return children.props.id;
  if (typeof children !== 'string' || !translate) return null;
  const text = normalize(children);
  return ICON_LABEL_KEYS.find((key) => normalize(translate(key)) === text) ?? null;
};

export const getButtonIcon = (labelKey) =>
  (labelKey?.startsWith(LABEL_PREFIX) ? BUTTON_ICONS[labelKey.slice(LABEL_PREFIX.length)] : null) ?? null;
